if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        let quantityLoadingOverlay = this.querySelector('.quantity__rules-cart .loading-overlay');
        if (quantityLoadingOverlay) {
          this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        }

        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (quantityLoadingOverlay) {
              this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
            }
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

// action show modal shippping
$(document).ready(function () {
  if ($(window).width() < 798) {
    $(".date-time-new").on("click", function () {
      $(".new-shipping ~.modal-shipping .wt-grid").toggleClass(
        "box-hover-shipping"
      );
    });

    $(document).click(function (e) {
      var container = $(".date-time-new");

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".new-shipping ~.modal-shipping .wt-grid").addClass(
          "box-hover-shipping"
        );
      }
    });
  } else {
    $(".date-time-new").hover(
      function () {
        $(".new-shipping ~.modal-shipping .wt-grid").toggleClass(
          "box-hover-shipping"
        );
      },
      function () {
        $(".new-shipping ~.modal-shipping .wt-grid").toggleClass(
          "box-hover-shipping"
        );
      }
    );
  }
});
//show action upload image
const classClosePhoto = [
  ".closed-photo-image",
  ".upload_image_guidelines",
  ".closed-bg-photo",
];
classClosePhoto.forEach(function (nameClass) {
  var element = document.querySelector(nameClass);
  if (element) {
    element.addEventListener("click", function () {
      document.querySelector(".modal-custom-image").classList.toggle("hidden");
      document.querySelector(".closed-bg-photo").classList.toggle("hidden");
    });
  }
});

const classPhotoGift = [
  ".photo-gift",
  ".closed-photo-gift",
  ".closed-bg-photo-gift",
];
classPhotoGift.forEach(function (nameClass) {
  var element = document.querySelector(nameClass);
  if (element) {
    element.addEventListener("click", function () {
      document.querySelector(".modal-photo-gift").classList.toggle("hidden");
      document
        .querySelector(".closed-bg-photo-gift")
        .classList.toggle("hidden");
    });
  }
});

// remove loading btn preview btn-preview-desktop
$(function () {
  if ($("#customily-options:not([style*='display: none;'])").length) {
    const timerRemoveLoadingPreview = setInterval(function () {
      if (
        $(
          "#customily-options:not([style*='display: none;']) ~.product-form__buttons #customily-cart-btn:not(.running)"
        ).length
      ) {
        $("#btn-preview-desktop").removeClass("ld-custom");
        $("#btn-preview").removeClass("ld-custom");
        $(".product-form__submit").removeClass("ld-custom");
        clearInterval(timerRemoveLoadingPreview);
      }
    }, 100);
  }

});

$("#preview-close, #preview-overlay").on("click", function (e) {
  if (
    window.innerWidth < 992 &&
    $(".gallery-wrap.gallery-arrows--false.gallery-thumbnails--left.slider-mobile-gutter").children(".canvas-wrapper").length <= 0 &&
    $(".product_name_title").text()?.indexOf('Photo') != -1
  ) {
    $(".gallery-wrap.gallery-arrows--false.gallery-thumbnails--left.slider-mobile-gutter").prepend($canvasWrapper);
  }
  e.preventDefault();
  $("#preview-container").toggleClass("hidden");
});

function check_valid() {
  $("form #customily-options .swatch-container").each(function () {
    var $checked = $(this).find('input[type="radio"]:checked');
    if ($checked.length) {
      $(this)
        .closest(".customily_option")
        .removeClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .hide();
    } else {
      $(this).closest(".customily_option").addClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .show();
    }
  });

  $("form #customily-options select").each(function () {
    if ($(this).val()) {
      $(this)
        .closest(".customily_option")
        .removeClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .hide();
    } else {
      $(this).closest(".customily_option").addClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .show();
    }
  });

  $('form #customily-options input[type="text"]').each(function () {
    if ($(this).val().length) {
      $(this)
        .closest(".customily_option")
        .removeClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .hide();
    } else {
      $(this).closest(".customily_option").addClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .show();
    }
  });
  $("form #customily-options textarea").each(function () {
    if ($(this).val().length) {
      $(this)
        .closest(".customily_option")
        .removeClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .hide();
    } else {
      $(this).closest(".customily_option").addClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .show();
    }
  });

  $("form #customily-options .customily-file-input").each(function () {
    var $checked = $(this).find(".cl_remove-image").is(":visible");
    if ($checked) {
      $(this)
        .closest(".customily_option")
        .removeClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .hide();
    } else {
      $(this).closest(".customily_option").addClass("customily-required-error");
      $(this)
        .closest(".customily_option")
        .find(".customily-required-label span")
        .show();
    }
  });
}
$("#btn-preview, #btn-preview-desktop").on("click", function (e) {
  e.preventDefault();
  check_valid();

  if ($(".customily_option").hasClass("customily-required-error") || 
      $(".customily_option").hasClass("customily-required-error") && $(".customily_option").css("display") != "none") {
    // alert(
    //   "Please check your design once again. Some required options have been left empty, unselected, or wrongly filled."
    // );
    $("#preview-container").hide();
    $(".customily-required-error input").first().focus();
    $(".customily-required-error")[0].scrollIntoView();
    $(".customily-required-error select").first().focus();
    $(".customily-required-error textarea").first().focus();
    return;
  }
  if (window.innerWidth < 992 && $(".product_name_title").text()?.indexOf('Photo') != -1) {
    $canvasWrapper = $(".canvas-wrapper");
    $(".preview-image-wrap").html($canvasWrapper);
  } else {
    const canvas = document.getElementById("preview-canvas");
    const dataURL = canvas.toDataURL();
    $("#preview-img").attr("src", dataURL);
  }

  $("#preview-container").removeClass("hidden");
  $("#preview-container").show();
});

$("#js-save-properties-product-preview").on("click", function (e) {
  $("#customily-cart-btn-preview").addClass("ld-custom");
  $("#customily-cart-btn").trigger("click");
});